<template>
  <div>
    <BlocoFormularioCadastro voltar="/evolucao/questao" @salvar="salvar()">
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="panel panel-primary">
              <div class="panel-heading">
                <h4>Questão</h4>
              </div>
              <div class="panel-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <CampoGenerico
                      id="enunciadoQuestaoCadastro"
                      :valor="questao.enunciado"
                      :validacao="v$.questao.enunciado"
                      label-sup="(1)"
                      placeholder="Enunciado da questão"
                      label="Enunciado"
                      @atualizar="questao.enunciado = $event"
                    >
                      <template #mensagensValidacao>
                        <span
                          v-if="!v$.questao.enunciado.required"
                          class="help-block"
                        >
                          Campo é obrigatório.
                        </span>
                        <span
                          v-if="!v$.questao.enunciado.minLength"
                          class="help-block"
                        >
                          Campo deve ter pelo menos
                          {{ v$.questao.enunciado.$params.minLength.min }}
                          letras.
                        </span>
                        <span
                          v-if="!v$.questao.enunciado.maxLength"
                          class="help-block"
                        >
                          Campo deve ter no máximo
                          {{ v$.questao.enunciado.$params.maxLength.max }}
                          letras.
                        </span>
                      </template>
                    </CampoGenerico>
                  </div>
                  <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                    <SelecionarDominio
                      id="tipoResposta"
                      :valor="questao.tipo"
                      :validacao="v$.questao.tipo"
                      :mostrar-todos="false"
                      dominio="TipoResposta"
                      label="Tipo da resposta"
                      label-sup="(1)"
                      @atualizar="questao.tipo = $event"
                    >
                      <template #mensagensValidacao>
                        <span
                          v-if="!v$.questao.tipo.required"
                          class="help-block"
                        >
                          Campo é obrigatório.
                        </span>
                      </template>
                    </SelecionarDominio>
                  </div>
                  <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                    <div
                      :class="{ 'has-error': v$.questao.obrigatorio.$error }"
                      class="form-group"
                    >
                      <label for="respostaObrigatoria">
                        Resposta obrigatória? <sup>(1)</sup>
                      </label>
                      <select
                        id="respostaObrigatoria"
                        v-model="questao.obrigatorio"
                        class="form-control"
                      >
                        <option value="true">Sim</option>
                        <option value="false">Não</option>
                      </select>
                      <div
                        v-if="v$.questao.obrigatorio.$dirty"
                        class="help-block"
                      >
                        <span v-if="!v$.questao.obrigatorio.required">
                          Campo é obrigatório.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                    <SelecionarSituacao
                      :label-sup="'(1)'"
                      :validacao="v$.questao.ativo"
                      :valor="questao.ativo"
                      :mostrar-todos="false"
                      @atualizar="questao.ativo = $event"
                    >
                      <template #mensagensValidacao>
                        <span
                          v-if="!v$.questao.ativo.required"
                          class="help-block"
                        >
                          Campo é obrigatório.
                        </span>
                      </template>
                    </SelecionarSituacao>
                  </div>
                </div>
                <div class="row">
                  <div
                    v-if="questao.tipo === 'Data'"
                    class="col-xs-12 col-sm-4 col-md-4 col-lg-4"
                  >
                    <SelecionarData
                      id="respostaPadraoData"
                      :valor="questao.respostaPadrao"
                      label="Resposta padrão"
                      @atualizar="questao.respostaPadrao = $event"
                    >
                    </SelecionarData>
                  </div>
                  <div
                    v-else-if="questao.tipo === 'Inteiro'"
                    class="col-xs-12 col-sm-4 col-md-4 col-lg-4"
                  >
                    <div class="form-group">
                      <label for="respostaPadraoInteiro">Resposta padrão</label>
                      <input
                        id="respostaPadraoInteiro"
                        v-model="questao.respostaPadrao"
                        v-mask="'999'"
                        class="form-control"
                        type="number"
                      />
                    </div>
                  </div>
                  <div
                    v-else-if="questao.tipo === 'Fracionário'"
                    class="col-xs-12 col-sm-4 col-md-4 col-lg-4"
                  >
                    <div class="form-group">
                      <label for="respostaPadraoFracionario"
                        >Resposta padrão
                      </label>
                      <input
                        id="respostaPadraoFracionario"
                        v-model="questao.respostaPadrao"
                        v-mask="'money'"
                        class="form-control"
                        type="text"
                      />
                    </div>
                  </div>
                  <div
                    v-else-if="questao.tipo === 'Sim/Não'"
                    class="col-xs-12 col-sm-4 col-md-4 col-lg-4"
                  >
                    <div class="form-group">
                      <label for="respostaPadraoSimNao">Resposta padrão</label>
                      <select
                        id="respostaPadraoSimNao"
                        v-model="questao.respostaPadrao"
                        class="form-control"
                      >
                        <option value="">Selecione</option>
                        <option value="true">Sim</option>
                        <option value="false">Não</option>
                      </select>
                    </div>
                  </div>
                  <div v-else-if="questao.tipo === 'Domínio'">
                    <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                      <div class="fomr-group">
                        <label for="respostaDominioNome">Domínio</label>
                        <select
                          id="respostaDominioNome"
                          v-model="questao.dominio"
                          class="form-control"
                        >
                          <option
                            v-for="d in dominios"
                            :key="d._id"
                            :value="d.nome"
                          >
                            {{ d.nomeExibicao || d.nome }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8">
                      <div v-if="questao.dominio">
                        <div class="fomr-group">
                          <label for="respostaPadraoDominio"
                            >Resposta padrão</label
                          >
                          <select
                            id="respostaPadraoDominio"
                            v-model="questao.respostaPadrao"
                            class="form-control"
                          >
                            <option
                              v-for="d in dominios.find(
                                (d) => d.nome === questao.dominio
                              ).valores"
                              :key="d._id"
                              :value="d.valor"
                              >{{ d.valor }}</option
                            >
                          </select>
                        </div>
                      </div>
                      <div v-else>
                        <div class="form-group">
                          <label>Resposta padrão</label>
                          <input class="form-control" type="text" disabled />
                          <span class="help-block text-warning">
                            Selecione um domínio.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="questao.tipo === 'Texto'" class="panel panel-primary">
              <div class="panel-heading">
                <h4>Respostas padrão</h4>
              </div>
              <div class="panel-body">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div class="form-group">
                    <label>Título</label>
                    <input
                      v-model="respostaPadrao.titulo"
                      type="text"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div class="form-group">
                    <label>Texto</label>
                    <Editor v-model="respostaPadrao.texto" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <Longpress
                      v-if="respostasPadroesSelecionadas.length"
                      :on-confirm="limparRespostasPadroesSelecionadas"
                      class="btn btn-danger"
                      duration="2"
                      pressing-text="Removendo selecionados {$rcounter}"
                      action-text="Removido"
                    >
                      <span class="fa fa-trash" /> Remover
                      {{ respostasPadroesSelecionadas.length }} selecionados
                    </Longpress>
                    <Longpress
                      v-else
                      :on-confirm="
                        () => limparRespostasPadroesSelecionadas(true)
                      "
                      class="btn btn-danger"
                      duration="3"
                      pressing-text="Removendo {$rcounter}"
                      action-text="Removido"
                    >
                      <span class="fa fa-trash" /> Remover todos
                    </Longpress>
                    <button
                      id="botaoAdicioar"
                      type="button"
                      class="btn btn-success"
                      @click="adicionarRespostaPadrao()"
                    >
                      <span class="fa fa-plus" /> Adicionar
                    </button>
                  </div>
                </div>
                <br />
                <div v-if="!questao.respostasPadroes.length" class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="well">
                      <p>Nenhuma resposta padrão.</p>
                    </div>
                  </div>
                </div>
                <div v-else class="row">
                  <div style="height: 415px; overflow: auto">
                    <div
                      v-for="(resp, index) in questao.respostasPadroes"
                      :key="index"
                      class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
                    >
                      <div class="panel panel-default">
                        <div class="panel-heading">
                          <label>
                            <input
                              style="margin-right: 8px"
                              type="checkbox"
                              @click="respostaPadraoToggle($event, resp)"
                            />
                            <input
                              v-model="resp.titulo"
                              class="titulo-input"
                              type="text"
                            />
                          </label>
                          <div class="pull-right">
                            <Longpress
                              :value="resp"
                              :on-confirm="removerRespostaPadrao"
                              class="btn btn-default btn-xs"
                              duration="1"
                              pressing-text="Removendo {$rcounter}"
                              action-text="Removido"
                            >
                              Remover
                            </Longpress>
                          </div>
                        </div>
                        <Editor v-model="resp.texto" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </BlocoFormularioCadastro>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { maxLength, minLength, required } from '@vuelidate/validators'
import AwesomeMask from 'awesome-mask'
import Longpress from 'vue-longpress'

import Editor from '@/componentes/formulario/Editor'
import { useMenu } from '@/composables/useMenu'
import { cadastroMixin } from '@/mixins/CadastroMixin'
import DominioServico from '@/servicos/DominioServico'
import MensagemServico from '@/servicos/MensagemServico'
import QuestaoServico from '@/servicos/QuestaoServico'

const dominiooServico = new DominioServico()
const mensagemServico = new MensagemServico()

export default {
  directives: { mask: AwesomeMask },
  components: {
    Editor,
    Longpress,
  },
  mixins: [cadastroMixin],
  setup() {
    useMenu(48)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      entidade: 'questao',
      consulta: 'Questao',
      servico: new QuestaoServico(),
      dominios: [],
      respostaPadrao: { titulo: '', texto: '' },
      respostasPadroesSelecionadas: [],
      questao: {
        ativo: 'true',
        enunciado: '',
        tipo: '',
        obrigatorio: 'false',
        respostaPadrao: '',
        respostasPadroes: [],
        dominio: '',
      },
    }
  },
  validations: {
    questao: {
      enunciado: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(200),
      },
      tipo: { required },
      obrigatorio: { required },
      ativo: { required },
    },
  },
  created() {
    this.recuperarDominios()
  },
  methods: {
    recuperarDominios() {
      dominiooServico.recuperarTodos({}).then((result) => {
        this.dominios = result.dominios
      })
    },
    processarEntidade() {},
    removerRespostaPadrao(respostaPadrao) {
      const index = this.questao.respostasPadroes.indexOf(respostaPadrao)
      this.questao.respostasPadroes.splice(index, 1)
    },
    limparRespostasPadroesSelecionadas(removerTodos = false) {
      if (removerTodos) {
        this.questao.respostasPadroes = []
      } else {
        for (const resp of this.respostasPadroesSelecionadas) {
          this.removerRespostaPadrao(resp)
        }
      }

      this.respostasPadroesSelecionadas = []
    },
    adicionarRespostaPadrao() {
      if (!this.respostaPadrao.titulo || !this.respostaPadrao.texto) {
        mensagemServico.alerta(
          'Informe valores válidos para o título e texto da resposta padrão!'
        )
        return
      }

      this.questao.respostasPadroes.push({ ...this.respostaPadrao })
      this.respostaPadrao.titulo = ''
      this.respostaPadrao.texto = ''
    },
    respostaPadraoToggle(e, resp) {
      const valor = e.target.checked

      if (valor) {
        this.respostasPadroesSelecionadas.push(resp)
      } else {
        const index = this.respostasPadroesSelecionadas.indexOf(resp)
        this.respostasPadroesSelecionadas.splice(index, 1)
      }
    },
  },
}
</script>

<style scoped>
.titulo-input {
  border: none;
  background: transparent;
}
</style>
